export default __webpack_public_path__ + "static/media/complementary--working-days--g1.313bbb27.png";